import PropTypes from 'prop-types'
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import AceEditor from 'react-ace'

const ContentCodeView = forwardRef(({
  jsxContent,
  onJsxContentChange
}, ref) => {
  const editorRef = useRef(null)
  const currentValueRef = useRef(jsxContent || '')

  // Expose getValue method to parent components
  useImperativeHandle(ref, () => ({
    getValue: () => currentValueRef.current,
    focus: () => {
      if (editorRef.current?.editor) {
        editorRef.current.editor.focus()
      }
    }
  }))

  // Only update editor when prop changes externally (e.g., AI generation, revert)
  useEffect(() => {
    if (jsxContent !== currentValueRef.current) {
      currentValueRef.current = jsxContent || ''
      // Editor will update via defaultValue on mount, or we can force update if needed
      if (editorRef.current?.editor) {
        const editor = editorRef.current.editor
        const cursorPosition = editor.getCursorPosition()
        editor.setValue(jsxContent || '', 1)
        editor.moveCursorToPosition(cursorPosition)
      }
    }
  }, [jsxContent])

  const handleChange = (value) => {
    currentValueRef.current = value
    if (onJsxContentChange) {
      onJsxContentChange(value)
    }
  }

  return (
    <div className='h-full'>
      <AceEditor
        ref={editorRef}
        height='calc(100%)'
        width='100%'
        mode='jsx'
        theme='xcode'
        name='jsx-editor'
        editorProps={{ $blockScrolling: true }}
        defaultValue={jsxContent || ''}
        onChange={handleChange}
        tabSize={2}
      />
    </div>
  )
})

ContentCodeView.displayName = 'ContentCodeView'

ContentCodeView.propTypes = {
  jsxContent: PropTypes.string,
  onJsxContentChange: PropTypes.func
}

export default ContentCodeView
